import i18n from "i18next";

// Training language for generated content and quiz chrome, independent of the
// editor UI. globalConfig.contentLanguage → voice profile → editor language.

// Languages a training can be created in (console).
export const CONTENT_LANGUAGES = ["tr", "en", "es", "de", "fr", "ar", "az", "ja"];
// Languages Studio has translation tables for.
export const TRANSLATED_LANGUAGES = ["tr", "en", "es"];

const LOCALES = {
  tr: "tr-TR",
  en: "en-US",
  es: "es-ES",
  de: "de-DE",
  fr: "fr-FR",
  ar: "ar-SA",
  az: "az-AZ",
  ja: "ja-JP",
};
const ENGLISH_NAMES = {
  tr: "Turkish",
  en: "English",
  es: "Spanish",
  de: "German",
  fr: "French",
  ar: "Arabic",
  az: "Azerbaijani",
  ja: "Japanese",
};

let stateLanguage = null;

export function normalizeContentLanguage(lang) {
  if (!lang || typeof lang !== "string") return null;
  const base = lang.toLowerCase().split(/[-_]/)[0];
  return CONTENT_LANGUAGES.includes(base) ? base : null;
}

export function setContentLanguage(lang) {
  stateLanguage = normalizeContentLanguage(lang);
}

export function getProfileContentLanguage() {
  const profile = typeof window !== "undefined" ? window.idealStudioVoiceProfile : null;
  return (
    normalizeContentLanguage(profile && profile.contentLanguage) ||
    normalizeContentLanguage(profile && profile.voiceLanguage)
  );
}

export function getContentLanguage() {
  return (
    stateLanguage || getProfileContentLanguage() || normalizeContentLanguage(i18n.language) || "tr"
  );
}

// Full locale ("tr-TR") for media providers.
export function getContentLocale() {
  return LOCALES[getContentLanguage()];
}

// The training locale if `offered` lists it, else `fallback`.
export function pickContentLocale(offered, fallback) {
  const locale = getContentLocale();
  return offered.includes(locale) ? locale : fallback;
}

// English language name ("Turkish").
export function getContentLanguageName() {
  return ENGLISH_NAMES[getContentLanguage()];
}

// Falls back to the editor language when Studio has no table for the training's.
function translationLanguage() {
  const lang = getContentLanguage();
  if (TRANSLATED_LANGUAGES.includes(lang)) return lang;
  const editor = normalizeContentLanguage(i18n.language);
  return TRANSLATED_LANGUAGES.includes(editor) ? editor : "tr";
}

export function contentT(key, options) {
  return i18n.getFixedT(translationLanguage())(key, options);
}

// Drop-in for `i18n` in learner-facing plugin code.
export const contentI18n = {
  t: contentT,
  get language() {
    return getContentLanguage();
  },
};
